/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function OrganizationPaymentAddonFromJSON(json) {
    return OrganizationPaymentAddonFromJSONTyped(json, false);
}
export function OrganizationPaymentAddonFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        userOptionQuantity: !exists(json, 'user_option_quantity') ? undefined : json['user_option_quantity']
    };
}
export function OrganizationPaymentAddonToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user_option_quantity: value.userOptionQuantity
    };
}
